import { html } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';
import '../../../demos/storage.js';

export const demoFunc = () => demoPage('Files', 'Browse, preview, and organize the files behind your workspace.', html`<dees-demo-storage-workspace></dees-demo-storage-workspace>`);
